import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import { dispatchToggleDismiss, dispatchToggleSave } from 'store/jobs/actions';

import classes from './index.module.css';

class JobDismissBanner extends React.Component {
  static propTypes = {
    minTopOffset: PropTypes.number,
    maxTopOffset: PropTypes.number,
    dispatchToggleDismiss: PropTypes.func.isRequired,
  };

  static defaultProps = {
    minTopOffset: 0,
    maxTopOffset: 0,
  };

  state = {
    show: false,
    lastDismissedJob: null,
    style: {},
  };

  componentDidMount() {
    // react to jobDismiss custom event
    document.addEventListener('jobDismissed', this.jobDismissed);

    // adjust the stick position of dismiss bar
    document.addEventListener('scroll', this.adjustTopOffset);
  }

  componentWillUnmount() {
    document.removeEventListener('jobDismissed', this.jobDismissed);
    document.removeEventListener('scroll', this.adjustTopOffset);
  }

  jobDismissed = ({ detail }) => {
    // swap last dismissed job
    this.setState(
      {
        lastDismissedJob: detail.job,
        show: true,
      },
      () => {
        this.adjustTopOffset();
        setTimeout(() => {
          this.setState({
            show: false,
          });
        }, 5000);
      }
    );
  };

  adjustTopOffset = () => {
    // set top position
    let HEIGHT_OF_HEADER = 0;
    if (document.getElementsByTagName('header')[0]) {
      HEIGHT_OF_HEADER = document.getElementsByTagName('header')[0].clientHeight;
    }
    const scrollTop =
      window.pageYOffset ||
      (document.documentElement || document.body.parentNode || document.body).scrollTop;
    let topOffset = 0;
    const { minTopOffset, maxTopOffset } = this.props;
    if (scrollTop <= HEIGHT_OF_HEADER) {
      topOffset = HEIGHT_OF_HEADER - scrollTop + minTopOffset;
    } else if (scrollTop > HEIGHT_OF_HEADER) {
      topOffset = minTopOffset;
    }
    if (maxTopOffset && topOffset > maxTopOffset) {
      topOffset = maxTopOffset;
    }
    this.setState(() => ({
      style: {
        top: `${topOffset}px`,
      },
    }));
  };

  undo = () => {
    const { lastDismissedJob } = this.state;
    if (!lastDismissedJob) return;
    // dispatch event on undo
    const { dispatchToggleDismiss, dispatchToggleSave, recentFavoriteJob } = this.props;

    document.dispatchEvent(
      new CustomEvent('jobUndismissed', {
        bubbles: true,
        detail: { job: lastDismissedJob },
      })
    );
    dispatchToggleDismiss({ job: lastDismissedJob });
    !_isEmpty(recentFavoriteJob) && dispatchToggleSave({ job: recentFavoriteJob });
    this.setState(() => ({
      show: false,
      lastDismissedJob: null,
    }));
  };

  render() {
    const { style, show } = this.state;
    if (!show) {
      return null;
    }
    return (
      <div
        style={style}
        className={classNames(
          classes.bannerJobRemoved,
          'd-flex',
          'flex-column',
          'justify-content-center',
          'align-items-center'
        )}
      >
        <p className="my-0">Dismissed: We’ll show you less like this</p>
        <p className={classNames(classes.clickedLink, 'my-0')} onClick={this.undo}>
          Click to undo
        </p>
      </div>
    );
  }
}

const mapStateToProps = ({ jobs: { recentFavoriteJob } }) => ({ recentFavoriteJob });

const mapDispatchToProps = {
  dispatchToggleDismiss,
  dispatchToggleSave,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobDismissBanner);
